"use client";
// Header, mobil sidebar (list/detail) gibi birden çok yerde <Search/> mount
// olabiliyor. PhotoSearchSheet'i her SearchInput kendi local state'iyle
// açsaydı, sidebar kapanırken (unmount) o sheet de yok olurdu — halbuki
// kamera butonuna basınca sidebar kapanıp modalın açık kalması gerekiyor.
// Bu yüzden sheet tek, her zaman mount kalan bir yerden (layout.tsx) ve
// paylaşılan Redux state'inden render edilir.
import { useRouter } from "next/navigation";
import { useCallback } from "react";
import PhotoSearchSheet from "./PhotoSearchSheet";
import useSearch from "@/app/lib/features/search/search.hook";

const GlobalPhotoSearchSheet = () => {
  const router = useRouter();
  const { isPhotoSearchOpen, closePhotoSearchSheet, fetchImageSearchResults } =
    useSearch();

  const handlePhotoSearch = useCallback(
    async (file: File) => {
      const ok = await fetchImageSearchResults(file);
      if (ok) router.push("/aramasonucu?search_type=image");
    },
    [fetchImageSearchResults, router],
  );

  return (
    <PhotoSearchSheet
      isOpen={isPhotoSearchOpen}
      onClose={closePhotoSearchSheet}
      onPhotoSearch={handlePhotoSearch}
    />
  );
};

export default GlobalPhotoSearchSheet;
